import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=d2831630&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=d2831630&prod&scoped=true&lang=scss"
import style1 from "./Banner.vue?vue&type=style&index=1&id=d2831630&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2831630",
  null
  
)

export default component.exports